var PriorityQueue =
/** @class */
function () {
  function PriorityQueue() {
    this.arr = [];
    this.prios = [];
  }

  PriorityQueue.prototype.add = function (t, prio) {
    for (var i = 0; i < this.arr.length; i++) {
      if (this.prios[i] < prio) {
        this.arr.splice(i, 0, t);
        this.prios.splice(i, 0, prio);
        return;
      }
    }

    this.arr.push(t);
    this.prios.push(prio);
  };

  PriorityQueue.prototype.forEach = function (f) {
    for (var i = 0; i < this.arr.length; i++) {
      f(this.arr[i], i, this.arr);
    }
  };

  PriorityQueue.prototype.delete = function (t) {
    for (var i = 0; i < this.arr.length; i++) {
      if (this.arr[i] === t) {
        this.arr.splice(i, 1);
        this.prios.splice(i, 1);
        return;
      }
    }
  };

  return PriorityQueue;
}();

export default PriorityQueue;